/**
 * 타이포그래피 상수 정의
 * 일관된 텍스트 스타일 제공
 */

export const typography = {
  fontFamily: '"Malgun Gothic", "맑은 고딕", AppleSDGothicNeo-Light, sans-serif',
  
  fontSize: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '2.5rem',
  },
  
  fontWeight: {
    normal: 400,
    medium: 500,
    bold: 700,
  },
  
  lineHeight: {
    normal: '1.5em',
    compact: '26px',
    tight: '1.2em',
  },
};

export default typography;

